import { Injectable } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {

  allRequests: any = [];

  constructor(
    private loaderService: NgProgress
  ) { }

  assignAllrequests(url) {
    this.allRequests.push(url);
    this.loaderService.start();
  }

  removeUrlOnresponse(url) {
    const index = this.allRequests.indexOf(url);
    if (index > -1) {
      this.allRequests.splice(index, 1);
    }

    if (this.allRequests.length === 0) {
      this.loaderService.done();
    }
  }

  checkForDuplicateUrl(url) {
    const index = this.allRequests.indexOf(url);
    if (index > -1) {
     return false;
    } else {
      return true;
    }
  }
}
